import EmblaCarousel, { type EmblaPluginType } from "embla-carousel";
import Autoplay from "embla-carousel-autoplay"; 
import Parallax from "../plugins/parallax";

export default (options = {}) => ({
  carousel: null,
  canScrollNext: false,
  canScrollPrev: false,
  slideCount: 0,
  scrollSnaps: 0,
  index: 0,
  init() {
    let plugins: Array<EmblaPluginType> = [];

    if ("autoplay" in this.$root.dataset) {
      plugins.push(
        Autoplay({
          delay: parseInt(this.$root.dataset.autoplay ?? "2500"),
          stopOnInteraction: false,
        }),
      );
    } 
    if ("parallax" in this.$root.dataset) {
      plugins.push(Parallax());
    }

    this.carousel = EmblaCarousel(
      this.$refs.carousel ?? this.$root,
      {
        align: "start",
        loop: true,
        skipSnaps: true,
        containScroll: "trimSnaps",
        ...options,
        ...(this.$refs.carousel && {
          container: this.$refs.carousel,
        }),
      },
      plugins,
    );

    this.carousel.on("init", (carousel) => {
      this.update(carousel);
    });

    this.carousel.on("select", (carousel) => {
      this.update(carousel);
      this.$dispatch("onselect", this.index);
    });

    this.carousel.on("resize", (carousel) => {
      this.update(carousel);
    });

    this.carousel.on("slidesChanged", (carousel) => {
      this.update(carousel);
    });
  },
  next() {
    this.carousel.scrollNext();
  },
  prev() {
    this.carousel.scrollPrev();
  },
  scrollTo(t) {
    this.carousel.scrollTo(t);
  },
  update(carousel) {
    if (!carousel) return;

    this.index = carousel.selectedScrollSnap();
    this.canScrollNext = carousel.canScrollNext();
    this.canScrollPrev = carousel.canScrollPrev();
    this.scrollSnaps = carousel.scrollSnapList();
    this.slideCount = carousel.slideNodes();
  },
  refresh() {
    if (this.carousel) {
      this.carousel.reInit();
      this.update(this.carousel);
    }
  },
  destroy() {
    if (this.carousel) {
      this.carousel.destroy();
    }
  },
});
